<!-- 项目介绍 -->
<template>
  <div
    class="pro_introduct_wrap bd_c_f"
    :style="{'height': `${lookMore ? `${this.contentHeight}px` : nolook ? loading ? '40px' : 'auto' : '250px'}`}"
  >
    <div
      class="pro_introduct_content"
      :class="loading  ? 'opacity_sty' : ''"
      ref="introContent"
      v-html="content"
    ></div>
    <div
      class="pro_introduct_btn_wrap"
      v-show="loading || !nolook"
      @click="handleLookMore"
    >
      <van-loading
        class="pro_introduct_loading"
        size="18"
        v-if="loading"
      />
      <van-icon
        v-else
        class="pro_introduct_btn"
        :name="lookMore ? 'arrow-up' : 'arrow-down'"
      />
    </div>

  </div>
</template>

<script>
export default {
  name: 'ProjectIntroduct',
  props: {
    content: {
      type: String,
      default: ''
    },
    is_collapse: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      lookMore: false,
      contentHeight: 40, // 251
      loading: true,
      htmlImg: 0,
      loadimg: -1
    }
  },

  watch: {
    is_collapse(value) {
      this.lookMore = value ? false : true
    },
    content(val) {
      if (val) {
        this.loadimg = 0
        this.oImgCallback()
        this.setAttribute()
        this.resetAclick()
      }
    },
    loadimg(val) {
      if (val != -1 && val == this.htmlImg) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.contentHeight = this.$refs.introContent.offsetHeight
            this.loading = false
          }, 1000);
        })
      }
    }
  },

  computed: {
    nolook() {
      return this.contentHeight < 250
    }
  },

  components: {},

  methods: {
    // 点击查看更多
    handleLookMore() {
      this.lookMore = !this.lookMore
      if (!this.lookMore) {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 510);
      }
    },
    // 获取项目介绍内容的高度
    getContentHeight() {
      return new Promise(resolve => {
        this.contentHeight = this.$refs.introContent.offsetHeight
        this.loading = false
        resolve()
      })
    },
    // 获取所有图片并绑定回调方法
    oImgCallback() {
      let url = []
      this.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, function (match, capture) {
        url.push(capture);
      })
      this.htmlImg = url.length
      if (url.length) {
        url.map((img) => {
          let oImg = new Image()
          oImg.src = img
          oImg.onload = this.imgLoaded()
        })
      }

    },
    // 图片加载完成
    imgLoaded() {
      this.loadimg++
      // console.log('loaded')
    },
    // 获取图片列表
    setAttribute() {
      this.$nextTick(() => {
        let imgs = document.getElementsByTagName('img')
        imgs.forEach(img => {
          if (!img.className) {
            let imgParent = img.parentNode
            imgParent.style.fontSize = 0
          }
        });
      })
    },
    // 重置a标签点击事件
    resetAclick() {
      this.$nextTick(() => {
        let eles = document.getElementsByTagName('a')
        eles.forEach(ele => {
          if (ele.href) {
            ele.onclick = () => {
              window.location.href = ele.href
            }
          }
        })
      })
    },
  },

  mounted() { },
}
</script>
<style lang="less" scoped>
.pro_introduct_wrap {
  position: relative;
  transition: all 0.5s ease-in-out;
  text-align: left;
  overflow: hidden;
  /deep/.pro_introduct_content {
    font-size: 14px;
    p {
      line-height: 1.2;
    }
    // span {
    //   width: 100%;
    //   display: inline-block;
    // }
    img {
      width: 100%;
    }
    strong,
    b {
      font-weight: bold;
    }
    em,
    i {
      font-style: italic;
    }
    hr {
      display: block !important;
      unicode-bidi: isolate !important;
      margin-block-start: 0.5em !important;
      margin-block-end: 0.5em !important;
      margin-inline-start: auto !important;
      margin-inline-end: auto !important;
      overflow: hidden !important;
      border-style: inset !important;
      border-width: 1px !important;
    }
    h1 {
      margin: 0.67em 0 !important;
      font-size: 2em !important;
      font-weight: bold !important;
    }
    h2 {
      margin: 0.83em 0 !important;
      font-size: 1.5em !important;
      font-weight: bold !important;
    }
    h3 {
      margin: 1.17em 0 !important;
      font-size: 1.17em !important;
      font-weight: bold !important;
    }
    h4 {
      // font-size: 12px !important;
      margin: 1.33em 0 !important;
      font-weight: bold !important;
    }
    h5 {
      margin: 1.67em 0 !important;
      font-size: 0.83em !important;
      font-weight: bold !important;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
    .ql-align-justify {
      text-align: justify;
    }
  }
  .opacity_sty {
    opacity: 0;
  }
  .pro_introduct_btn_wrap {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 98;
    text-align: center;
    font-size: 0;
    height: 40px;
    // background: linear-gradient(
    //   to top,
    //   rgba(255, 255, 255, 1),
    //   rgba(255, 255, 255, 0)
    // );
    .pro_introduct_btn {
      color: var(--bgColor);
      font-size: 18px;
      margin-top: 12px;
    }
    .pro_introduct_loading {
      color: var(--bgColor);
      margin-top: 12px;
    }
  }
}
.padd_bottom_40 {
  padding-bottom: 40px;
}

.pro_introduct_showMore {
  max-height: 1000px;
}
</style>
